import { useAuth } from '../context/AuthContext';
import { loginService } from '../services/auth.service';
import Logo from '../components/Logo';
import React, { useState, useEffect } from 'react';

const API = 'https://sendvigo-backend-production.up.railway.app';

const EyeIcon = ({ open }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    {open ? (
      <>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
        <circle cx="12" cy="12" r="3"/>
      </>
    ) : (
      <>
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
        <line x1="1" y1="1" x2="23" y2="23"/>
      </>
    )}
  </svg>
);

export default function Login({ onBack, onRegister }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotSent, setForgotSent] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotError, setForgotError] = useState('');

  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const name = params.get('name');
  const id = params.get('id');
  if (token && name && id) {
    login(token, { id: parseInt(id), name: decodeURIComponent(name) });
    window.history.replaceState({}, '', window.location.pathname);
  }
}, []);

  const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  const handleLogin = async () => {
    setError('');
    if (!email || !password) { setError('Rellena todos los campos'); return; }
    if (!isValidEmail(email)) { setError('El email no es válido'); return; }
    setLoading(true);
    try {
      const data = await loginService(email.toLowerCase().trim(), password);
      login(data.token, data.user);
    } catch (err) {
      setError(err.message || 'Email o contraseña incorrectos');
    }
    setLoading(false);
  };

  const handleKeyDown = (e) => { if (e.key === 'Enter') handleLogin(); };

  const handleForgot = async () => {
    setForgotError('');
    if (!forgotEmail) { setForgotError('Introduce tu email'); return; }
    if (!isValidEmail(forgotEmail)) { setForgotError('El email no es válido'); return; }
    setForgotLoading(true);
    try {
      await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail.toLowerCase().trim() }),
      });
      setForgotSent(true);
    } catch {
      setForgotError('Error al enviar el email');
    }
    setForgotLoading(false);
  };

  const inputStyle = {
    backgroundColor: '#13161c',
    border: '1px solid #2a2d35',
    color: 'white',
    borderRadius: '14px',
    padding: '14px 16px',
    fontSize: '14px',
    width: '100%',
    outline: 'none',
    transition: 'border-color 0.2s',
  };

  // Pantalla recuperar contraseña
  if (showForgot) return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{ backgroundColor: '#0d0f14' }}>
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: '300px',
        background: 'radial-gradient(ellipse 80% 50% at 50% -5%, #f9731612 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div className="w-full max-w-sm relative">
        <button onClick={() => { setShowForgot(false); setForgotSent(false); setForgotError(''); }}
          style={{ color: '#6b7280', fontSize: '13px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '6px', background: 'none', border: 'none', cursor: 'pointer' }}>
          ← Volver al login
        </button>

        {forgotSent ? (
          <div style={{ textAlign: 'center', paddingTop: '20px' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📬</div>
            <h2 style={{ color: 'white', fontWeight: '800', fontSize: '22px', marginBottom: '8px' }}>Revisa tu email</h2>
            <p style={{ color: '#6b7280', fontSize: '14px', lineHeight: '1.6' }}>
              Si ese email está registrado, recibirás un enlace para restablecer tu contraseña en unos minutos.
            </p>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '28px' }}>
              <h2 style={{ color: 'white', fontWeight: '800', fontSize: '22px', marginBottom: '6px' }}>¿Olvidaste tu contraseña?</h2>
              <p style={{ color: '#6b7280', fontSize: '13px', lineHeight: '1.5' }}>
                Introduce tu email y te enviamos un enlace para recuperarla.
              </p>
            </div>

            <input
              type="email"
              placeholder="tu@email.com"
              value={forgotEmail}
              onChange={e => setForgotEmail(e.target.value)}
              style={inputStyle}
              className="placeholder-gray-600 focus:ring-1 focus:ring-orange-500 mb-3"
            />

            {forgotError && (
              <div style={{ backgroundColor: '#ff000015', border: '1px solid #ff000030', color: '#f87171', borderRadius: '10px', padding: '10px 14px', fontSize: '13px', marginBottom: '12px' }}>
                {forgotError}
              </div>
            )}

            <button onClick={handleForgot} disabled={forgotLoading}
              style={{ backgroundColor: '#f97316', width: '100%', color: 'white', fontWeight: '700', padding: '14px', borderRadius: '14px', fontSize: '14px', opacity: forgotLoading ? 0.7 : 1, cursor: forgotLoading ? 'default' : 'pointer', border: 'none' }}>
              {forgotLoading ? 'Enviando...' : 'Enviar enlace'}
            </button>
          </>
        )}
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{ backgroundColor: '#0d0f14' }}>

      {/* Fondo decorativo */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: '300px',
        background: 'radial-gradient(ellipse 80% 50% at 50% -5%, #f9731612 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div className="w-full max-w-sm relative">

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
            <Logo />
          </div>
          <p style={{ color: '#f97316', fontSize: '12px', fontStyle: 'italic', opacity: 0.8 }}>
            Juntos llegamos más lejos 🤝
          </p>
        </div>

        {/* Card */}
        <div style={{
          backgroundColor: '#1a1d24', border: '1px solid #2a2d35',
          borderRadius: '24px', padding: '28px 24px',
        }}>
          <h2 style={{ color: 'white', fontWeight: '800', fontSize: '20px', marginBottom: '4px' }}>
            Bienvenido de vuelta
          </h2>
          <p style={{ color: '#6b7280', fontSize: '13px', marginBottom: '24px' }}>
            Inicia sesión para continuar
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '16px' }}>
            {/* Email */}
            <div>
              <label style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '6px' }}>
                Email
              </label>
              <input
                type="email"
                placeholder="tu@email.com"
                value={email}
                onChange={e => { setEmail(e.target.value); setError(''); }}
                onKeyDown={handleKeyDown}
                style={inputStyle}
                className="placeholder-gray-600"
              />
            </div>

            {/* Contraseña */}
            <div>
              <label style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '6px' }}>
                Contraseña
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setError(''); }}
                  onKeyDown={handleKeyDown}
                  style={{ ...inputStyle, paddingRight: '48px' }}
                  className="placeholder-gray-600"
                />
                <button
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', color: '#4b5563', background: 'none', border: 'none', cursor: 'pointer', display: 'flex' }}
                >
                  <EyeIcon open={showPassword} />
                </button>
              </div>
            </div>
          </div>
          

          {/* Olvidé contraseña */}
          <div style={{ textAlign: 'right', marginBottom: '16px' }}>
            <button onClick={() => setShowForgot(true)}
              style={{ color: '#f97316', fontSize: '12px', fontWeight: '600', background: 'none', border: 'none', cursor: 'pointer' }}>
              ¿Olvidaste tu contraseña?
            </button>
          </div>

          {error && (
            <div style={{ backgroundColor: '#ff000015', border: '1px solid #ff000030', color: '#f87171', borderRadius: '10px', padding: '10px 14px', fontSize: '13px', marginBottom: '14px' }}>
              {error}
            </div>
          )}

          <button onClick={handleLogin} disabled={loading}
            style={{ backgroundColor: '#f97316', width: '100%', color: 'white', fontWeight: '700', padding: '14px', borderRadius: '14px', fontSize: '14px', border: 'none', cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.8 : 1, transition: 'opacity 0.2s' }}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </div>

        {/* Registro */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <p style={{ color: '#6b7280', fontSize: '13px' }}>
            ¿Aún no tienes cuenta?{' '}
            <button onClick={onRegister}
              style={{ color: '#f97316', fontWeight: '700', background: 'none', border: 'none', cursor: 'pointer', fontSize: '13px' }}>
              Únete gratis
            </button>
          </p>
        </div>

        <p style={{ color: '#2a2d35', fontSize: '11px', textAlign: 'center', marginTop: '28px', lineHeight: '1.6' }}>
          Una comunidad de personas que se ayudan compartiendo el camino 🤝
        </p>
      </div>
    </div>
  );
}
